module.exports = __webpack_public_path__ + "img/dalou_8_2@2x.5c1e6a9b.png";